<template>
  <section>
    <div class="container is-grid">
      <div class="is-col-12-md">
        <h1>
          Edit My Account<br class="show-br-mobile"/> Details </h1>
        <p class="header-paragraph">
          Once you&rsquo;re finished making your changes, please remember to hit the “Save my details” button
          below. </p>
      </div>
      <form id="editAccountForm" @submit.prevent="sendFormData()">
        <div class="is-col-12-md">
          <div class="detail-row">
            <div class="left-column">
              <h2>Basic Information</h2>
              <table>
                <tr>
                  <td>
                    <p>
                      <strong><span>*</span> First Name</strong>
                    </p>
                  </td>
                  <td>
                    <input class="input-field" v-model="firstName" type="text" :class="{ invalid: errors.first_name }"
                           @input="clear_error('first_name')"/>
                    <p class="errorMsg-text" v-if="errors.first_name">
                      {{ errors.first_name[0] }} </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>
                      <strong><span>*</span> Last Name</strong>
                    </p>
                  </td>
                  <td>
                    <input class="input-field" v-model="lastName" type="text" :class="{ invalid: errors.last_name }"
                           @input="clear_error('last_name')"/>
                    <p class="errorMsg-text" v-if="errors.last_name">
                      {{ errors.last_name[0] }} </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>
                      <strong> <span>*</span> Email address</strong>
                    </p>
                  </td>
                  <td>
                    <input class="input-field" v-model="email" type="text" :class="{ invalid: errors.email }"
                           @input="clear_error('email')"/>
                    <p class="errorMsg-text" v-if="errors.email">
                      {{ errors.email[0] }} </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>
                      <strong> <span>*</span> Phone number</strong>
                    </p>
                  </td>
                  <td>
                    <input class="input-field" v-model="phoneNumber" v-maska="'(###) ###-####'"
                           placeholder="(###) ###-####" type="tel" :class="{ invalid: errors.phone }"
                           @input="clear_error('phone')"/>
                    <p class="errorMsg-text" v-if="errors.phone">
                      {{ errors.phone[0] }} </p>
                  </td>
                </tr>
              </table>
            </div>
            <div class="right-column">
              <h2>Practice Information</h2>
              <table>
                <tr>
                  <td>
                    <p>
                      <strong> <span>*</span>Specialty</strong>
                    </p>
                  </td>
                  <td>
                    <select v-model="specialty" :class="{ invalid: errors.specialty }"
                            @input="clear_error('specialty')">
                      <option value="" disabled>Please select</option>
                      <option v-for="spec in $store.state.specialties" :key="spec" v-html="spec"/>
                    </select> <span class="errorMsg-text" v-if="errors.specialty">{{
                      errors.specialty[0]
                    }}</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>
                      <strong><span>*</span> Practice name</strong>
                    </p>
                  </td>
                  <td>
                    <input class="input-field" v-model="practiceName" type="text"
                           :class="{ invalid: errors.practice_name }" @input="clear_error('practice_name')"/>
                    <p class="errorMsg-text" v-if="errors.practice_name">
                      {{ errors.practice_name[0] }} </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>
                      <strong><span>*</span> Zip Code</strong>
                    </p>
                  </td>
                  <td>
                    <input class="input-field" v-model="zipCode" type="text"
                           :class="{ invalid: errors.practice_zip_code }" @input="clear_error('practice_zip_code')"/>
                    <p class="errorMsg-text" v-if="errors.practice_zip_code">
                      {{ errors.practice_zip_code[0] }} </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>
                      <strong> NPI number</strong>
                    </p>
                  </td>
                  <td>
                    <p class="npi">{{ npiStateNumber }}</p>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <p class="errorMsg-text" v-if="errors.length != 0">
          Please check the form and ensure all fields are properly filled out. </p>
        <div class="button-row">
          <button>SAVE MY DETAILS <i class="fas fa-caret-right"></i></button>
        </div>
      </form>
    </div>
  </section>
</template>
<script>
export default {
  data: () => {
    return {
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber: '',
      zipCode: '',
      practiceName: '',
      npiStateNumber: '',
      specialty: '',
      errors: []
    }
  },
  created () {
    this.getFormData()
  },
  methods: {
    getFormData () {
      const _this = this
      _this.axios.get(_this.$apiUrl + 'v1/account').then(function (response) {
        if (response.data.errors.length === 0) {
          const d = response.data.user
          _this.firstName = d.first_name
          _this.lastName = d.last_name
          _this.email = d.email
          _this.phoneNumber = d.phone
          _this.specialty =
            _this.$store.state.specialties.indexOf(d.specialty) > 0
              ? d.specialty
              : '';
          (_this.npiStateNumber = d.npi_state_license_num),
          (_this.practiceName = d.practice_name)
          _this.zipCode = d.practice_zip_code
        } else {
          _this.errors = response.errors
          // TODO: Add error output above
        }
        _this.showResponse = true
      }).catch(function (error) {
        _this.output = error
      })
    },
    clear_error (field) {
      if (typeof this.errors[field] !== 'undefined') { delete this.errors[field] }
    },
    sendFormData () {
      const _this = this
      _this.axios.put(_this.$apiUrl + 'v1/account', {
        first_name: _this.firstName,
        last_name: _this.lastName,
        email: _this.email,
        phone: _this.phoneNumber.replace(/\D/g, ''),
        specialty: _this.specialty,
        npi_state_license_num: _this.npiStateNumber,
        practice_name: _this.practiceName,
        practice_zip_code: _this.zipCode
      }).then(function (response) {
        _this.showResponse = true
        if (response.data.errors.length === 0) {
          _this.$router.push({ name: 'AccountDetail' }).catch(() => {})
        } else {
          _this.errors = response.data.errors
          // TODO: Add error output above
        }
        _this.showResponse = true
      }).catch(function (error) {
        _this.errors = error.response.data.errors
        setTimeout(() => {
          document.querySelector('input.invalid,select.invalid').focus()
        }, 200)
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import (reference) "~@/assets/css/variables.less";

.container {
  display: flex;
  flex-flow: column wrap;
  @media screen and (max-width: 1000px) {
    padding-left: 20px;
  }

  h1 {
    font-size: 60px;
    text-transform: uppercase;
    text-align: left;
    margin-top: 60px;
    @media screen and (max-width: 1000px) {
      margin-top: 1.1em;
      font-size: 45px;
      text-align: center;
    }
  }

  h2 {
    @media screen and (max-width: 1000px) {
      font-size: 24px;
    }
  }

  .header-paragraph {
    @media screen and (max-width: 1000px) {
      width: 100%;
      margin-right: auto;
      font-size: 1.8em;
    }

    @media screen and (max-width: ~"@{mq-xs-bp}") {
      margin-left: 0;
    }
  }
}

p.npi {
  margin: 10px 0;
  line-height: 45px;
}

.left-column {
  padding-right: 10%;
  @media screen and (max-width: 1000px) {
    width: 100%;
    padding-right: 0;
    margin-bottom: 40px;
  }

  @media screen and (max-width: 768px) {
    width: 100%;
  }
}

.right-column {
  @media screen and (max-width: 1000px) {
    width: 100%;
  }
  @media screen and (max-width: 768px) {
    width: 100%;
  }
}

table {
  width: 100%;

  tr {
    @media screen and (max-width: 1000px) {
      display: flex;
      flex-direction: column;
      width: 100%;
    }

    td {
      width: 400px;
      border-bottom: 1px solid @color-border-lt-gray;
      @media screen and (max-width: 1000px) {
        padding-top: 0;
        padding-bottom: 0;
        border-bottom: none;
        width: 90%;
      }

      p {
        padding-left: 0px;
        font-size: 14px;
        width: 150px;
        font-family: @open-sans-font;
        @media screen and (max-width: 1000px) {
          font-size: 18px;
        }
      }

      span {
        color: #d80000;
      }

      &:nth-child(1) {
        text-align: left;
        padding-right: 20px;
        padding-bottom: 10px;
        border-bottom: 1px solid @color-border-lt-gray;
        border-right: 1px solid @color-border-lt-gray;
        @media screen and (max-width: 1000px) {
          border-bottom: none;
          border-right: none;
          padding-bottom: 0;
        }
      }

      &:nth-child(2) {
        p {
          padding-left: 30px;
          @media screen and (max-width: 1000px) {
            padding-left: 0;
          }
        }
      }
    }

    &:last-child {
      td {
        border-bottom: none;
      }
    }
  }
}

button {
  background-color: @color-orange;
  font-weight: 700;
  font-family: @open-sans-font;
  font-size: .clampedWrem(3, @md-bp, @large-bp) [ @result];
  text-transform: uppercase;
  border: none;
  padding: 0.7rem 0.7rem 0.7rem 0.7rem;
  margin-top: 20px;
  cursor: pointer;
  @media screen and (max-width: 1000px) {
    width: 230px;
    font-size: 20px;
  }

  .fa-caret-right {
    margin-left: 7px;
  }
}

select,
.input-field {
  width: 25.2rem;
  height: 4.5rem;
  margin: 10px 0 10px 20px;
  color: @color-txt-blue;
  font-size: 14px;
  @media screen and (max-width: 1000px) {
    width: 110%;
    margin-left: 0;
    margin-bottom: 20px;
    font-size: 18px;
  }
}

.invalid {
  margin-bottom: 5px;

  & + .errorMsg-text {
    padding-left: 20px;
    font-size: 1.5rem;
    margin: 0 0 10px 0;
    width: 100%;
  }
}

.detail-row {
  display: flex;
  flex: 1 50%;
  justify-content: center;
  @media screen and (max-width: 1000px) {
    flex-direction: column;
  }
}

.button-row {
  display: flex;
  flex-direction: column;
  width: 20%;

  button {
    background-color: @color-orange;
    font-weight: 700;
    font-family: @open-sans-font;
    font-size: .clampedWrem(3, @md-bp, @large-bp) [ @result];
    text-transform: uppercase;
    border: none;
    margin-top: 20px;
    padding: 1rem 1rem 1rem 1rem;
    cursor: pointer;
    @media screen and (max-width: 1000px) {
      width: 226px;
      font-size: 20px;
    }

    .fa-caret-right {
      margin-left: 7px;
    }
  }

  @media screen and (max-width: 1000px) {
    width: 80%;
    margin-left: 0;
  }
  @media screen and (max-width: ~"@{mq-xs-bp}em") {
    margin-left: unset;
  }

  a {
    font-size: 18px;
    margin-bottom: 20px;
  }
}

.selectField {
  margin: 10px 0 0 20px;
  @media screen and (max-width: 1000px) {
    margin-left: 0;
  }
  padding: 0;

  select {
    font-size: 14px;
    color: @color-txt-blue;
    height: 4.5rem;
    @media screen and (max-width: 1000px) {
      width: 110%;
    }
  }

  &::after {
    right: 5px;
    @media screen and (max-width: 1000px) {
      right: -31px;
    }
  }
}
</style>
